import { actionTypes, change as reduxChange } from 'redux-form';

import { getCurrency, getDefaultCurrency } from '../apiHelpers';

import Currency from '../enums/Currency';

export default store => next => action => {
	// let the action go to the reducers
	next(action);

	if (action.type === actionTypes.INITIALIZE) {
		const state = store.getState();

		// Nastavíme výchozí měnu
		if (state.app.currencies) {
			let currency = ((['en', 'de', 'fr'].includes(state.app.lang)) && getCurrency(state.app.currencies, Currency.EUR))
				|| getDefaultCurrency(state.app.currencies);

			store.dispatch(reduxChange('bookingForm', 'currency', currency));
		}

		// Nastavíme výchozí jazyk
		store.dispatch(reduxChange('bookingForm', 'lang', state.app.lang));
	}
};


// WEBPACK FOOTER //
// ./src/store/reduxMiddleware.js